import { createFileRoute, redirect } from '@tanstack/react-router';

import { clearStoredOnboardingUrl, getStoredOnboardingUrl } from '../common/utils/onboardingRedirect.util';

export const Route = createFileRoute('/onboard-redirect')({
    beforeLoad: () => {
        const storedUrl = getStoredOnboardingUrl();

        if (storedUrl) {
            clearStoredOnboardingUrl();

            throw redirect({
                to: storedUrl,
                replace: true,
            });
        }

        throw redirect({
            to: '/login',
            replace: true,
        });
    },
});
